__turbopack_context__.v({
  "breadcrumbs": "EncyclopediaNav-module-scss-module__OugFUq__breadcrumbs",
  "encyclopedia-nav": "EncyclopediaNav-module-scss-module__OugFUq__encyclopedia-nav",
  "search": "EncyclopediaNav-module-scss-module__OugFUq__search",
});
